import { render, staticRenderFns } from "./SystemView.vue?vue&type=template&id=28027daa&"
import script from "./SystemView.vue?vue&type=script&lang=js&"
export * from "./SystemView.vue?vue&type=script&lang=js&"
import style0 from "./SystemView.vue?vue&type=style&index=0&id=28027daa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports